import { NAMETARH, CHANGE_NAMETARH } from 'src/State-Management/Actions/ActionTypes'

const NameTarhReducer = function (state = 0, action) {
    switch (action.type) {
        case NAMETARH:
            return state;
        case CHANGE_NAMETARH:
            sessionStorage.setItem('NameTarh', action.payload)
            return action.payload;
        default:
            return state;
    }
}

export default NameTarhReducer